import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-olive-dark text-white relative overflow-hidden" data-id="element-77">
      <div className="absolute inset-0 bg-brand-olive/20 blur-[100px] rounded-full max-w-3xl mx-auto" data-id="element-78" />

      <div className="max-w-2xl mx-auto relative z-10 text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-4 sm:mb-7" data-id="element-80">
          <h2 className="text-xl sm:text-4xl font-serif font-bold mb-4 sm:mb-6" data-id="element-81">
            Vuoi continuare a improvvisare ogni sera o vuoi finalmente un
            metodo?
          </h2>
          <p className="text-sm sm:text-lg text-gray-200 font-medium" data-id="element-82">
            Inizia oggi il tuo viaggio verso una vita più semplice, equilibrata
            e sostenibile.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-4" data-id="element-83">
          <CTAButton href="https://italia.kitonline.shop/cart/44759699554439:1" variant="premium" className="w-full sm:w-auto min-w-0 sm:min-w-[300px]" data-id="element-84">
            VOGLIO IL SISTEMA COMPLETO – €27,90
          </CTAButton>

          <p className="text-xs sm:text-sm text-gray-400" data-id="element-85">
            oppure{' '}
            <a href="https://italia.kitonline.shop/cart/44759694901383:1" className="text-white underline hover:text-brand-gold" data-id="element-86">
              VOGLIO IL PACCHETTO BASE – €19,90
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}